import React, {Component} from 'react';
import jQuery from 'jquery';

import '../../../assets/css/html5imageupload.css';
import '../../../assets/css/demo.html5imageupload.css';
import Avatar from 'react-avatar-edit';
import api from '../../../utils/api';

const $ = window && window.jQuery ? window.jQuery : jQuery;
/* global Blob */
/* global atob */

class AvatarModal extends React.Component {
    constructor(props){
        super(props);
        this.state = {
          preview: null,
          src: ''
        }
        this.onCrop = this.onCrop.bind(this)
        this.onClose = this.onClose.bind(this)
        this.onBeforeFileLoad = this.onBeforeFileLoad.bind(this)
    }
    
    componentDidMount(){
        if(this.props.profile){
            if(this.props.profile.image){
                this.setState({src: api.makeFileURL(this.props.profile.image, this.props.user.id)});
            }
        }
    }
    
    componentDidUpdate(props, state){
        if(props.profile && this.props.profile){
            if(props.profile.image !== this.props.profile.image){
                this.setState({src: api.makeFileURL(this.props.profile.image, this.props.user.id)});
            }
        }
    }
    
    onClose() {
        this.setState({preview: null})
      }
      
      onCrop(preview) {
        this.setState({preview})
      }
     
      onBeforeFileLoad(elem) {
        if(elem.target.files[0].size > 71680){
          
        };
      }
      
      
     dataURItoBlob = (dataURI) => {
    var byteString = atob(dataURI.split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/jpeg' });
}
    uploadAvatar = (e) => {
        const data = new FormData();
        data.append('file', this.dataURItoBlob(this.state.preview), this.props.profile.id + "-" + new Date().getTime().toString() + "-" + "image.png");

        this.props.uploadAvatar(data, this.props.profile.id, this.props.user.id);
        if(!this.props.standalone){
            this.props.dismiss();
        }
        //this.props.onUpdateVideo(this.props.video);


    }
    
    dismissAvatar = () => {
        let {profile} = this.props;
        profile.neverPromptAvatar = true;
        this.props.updateProfile(profile, this.props.user.id);
        if(!this.props.standalone){
            this.props.dismiss();
        }
    }
    
    renderContent = () => {
        return (
            <Avatar
                width={280}
              height={280}
              onCrop={this.onCrop}
              onClose={this.onClose}
              onBeforeFileLoad={this.onBeforeFileLoad}
              src={this.state.src}
              cropRadius={0}
            />    
        )
    }

    
    render(){
        if(this.props.standalone){
            return (
                <div>
                    {this.state.src ?
                        <div className="avatar-background" style={{background: "url('" + this.state.src + "')"}}></div>
                    : null}
                    {this.renderContent()}
                    <br />
                    <button type="button" className="btn btn-primary" onClick={e => this.uploadAvatar(e)}>Save Avatar</button>
                </div>
            )
        }else{
            return (
                <div className="modal fade in" id="uploadProfilePicModal" tabindex="-1" role="dialog" style={{display: 'block'}}>
                    <div className="modal-dialog modal-sm" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h4 className="modal-title">Upload your profile picture</h4>
                            </div>
                            <div className="modal-body">
                                {this.renderContent()}
                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal" onClick={e => this.dismissAvatar()}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={e => this.uploadAvatar(e)}>Save changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                   
            )
        }
    }
}

export default AvatarModal;


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/AvatarModal.js